import { getAccessTokenId } from 'shared/auth'
import axios from 'axios'

import { API_URL } from 'shared/config'

const instance = axios.create({
  baseURL: API_URL + '/api',
})

instance.interceptors.request.use(async function (config) {
  const token = await getAccessTokenId()

  if (token) {
    config.headers.setAuthorization(`Bearer ${token}`)
  }

  return config
})

export const isAxiosError = axios.isAxiosError.bind(axios)

export default instance
